import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ReportService } from 'src/app/services/report.service';
import { from, concat, zip } from 'rxjs';
import { map, filter, groupBy, reduce, mergeMap, toArray } from 'rxjs/operators';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class PrincipalComponent implements OnInit {
  loading = false;
  date:Date = null;
  actExpensesReport:boolean = true;
  data = [];
  total = 0;
  shTable: boolean = false;
  shTable2: boolean = false;
  @ViewChild('title') title;

  chartByUnity: any;
  width:number = 0;
  travels = null;

  constructor(private authService:AuthService, private reportServ:ReportService, private toastr:ToastrManager) { }

  ngOnInit() {
    this.width = this.title.nativeElement.offsetWidth;
    this.date = new Date();
    this.date.setMonth(this.date.getMonth() - 1);
    this.date.setDate(1);
    this.actExpensesReport = this.authService.can("get-report-total-expenses");
  }

  initGraph() {
    let labels = [];
    let data = [];
    zip(
      from(this.data)
        .pipe(map(x => x.trailer)),
      from(this.data)
        .pipe(map(x => x.total)),
    )
    .subscribe(x => {
      labels.push(x[0]); 
      data.push(x[1]);
    }, null, () => {
      this.chartByUnity = new Chart('byUnity', {
        type: this.width < 1024 ? 'horizontalBar' : 'bar',
        data: {
          labels,
          datasets: [{
            label: 'Utilidad',
            data,
            backgroundColor: 'rgb(14, 34, 64)',
            borderColor: 'rgb(226, 88, 41)',
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          },
          title: {
            display: true,
            text: 'Utilidad Por Unidad'
          },
        },
      });
    });
  }

  search () {
    this.loading = true;
    let date1 = new Date(this.date);
    date1.setMonth(date1.getMonth() - 1);
    date1.setDate(26);
    let date2 = new Date(this.date);
    date2.setMonth(date2.getMonth());
    date2.setDate(25);

    let tmpData = [];

    this.reportServ.totalExpensesReport(date1, date2, null).then(data => {
      let trailer0 = from(data).pipe(filter(r => this.filterData(r, 0)), map(r => this.mapData(r, 0)));
      let trailer1 = from(data).pipe(filter(r => this.filterData(r, 1)), map(r => this.mapData(r, 1)));
      let trailer2 = from(data).pipe(filter(r => this.filterData(r, 2)), map(r => this.mapData(r, 2)));
      let trailer3 = from(data).pipe(filter(r => this.filterData(r, 3)), map(r => this.mapData(r, 3)));

      concat(trailer0, trailer1, trailer2, trailer3).pipe(
          groupBy(r => r.trailer),
          mergeMap(r => r.pipe(toArray())),
          map(r => {
            let total = 0;

            for (let i = 0; i < r.length; i++) {
              total += r[i].result;
            }

            return {type: r[0].type, trailer: r[0].trailer, travels: r, total}
          }),
        )
        .subscribe(r => {
          let i = 0;
          for (i = 0; i < tmpData.length; i++) {
            if (tmpData[i].total <= r.total) {
              tmpData.splice(i, 0, r);
              break;
            }
          }

          if (i == tmpData.length) {
            tmpData.push(r);
          }

        }, null, () => {
          this.data = tmpData;

          //calc totales
          from(this.data)
            .pipe(
              map(x => x.total),
              reduce((act, ant) => act + ant, 0),
            ).subscribe(r => {
              this.total = r;
              this.initGraph();
              this.loading = false;
            })
        });
    });
  }

  mapData (r, n) {
    let div = ((r.trailer_1 ? 1 : 0) + (r.trailer_2  ? 1 : 0) + (r.trailer_3 ? 1 : 0));
    div = div == 0 ? 1 : div;

    return {
      id: r.id,
      trailer: n == 0 ? r.unity : r['trailer_' + n], 
      result: r.profit / div, 
      type: n == 0 ? r.unity_type : r['trailer_' + n + '_type'],
      travel: r,
    }
  }

  filterData(r, n) {
    if (n == 0) {
      return r.trailer_1 == null && r.trailer_2 == null && r.trailer_3 == null;
    } else {
      return r['trailer_' + n] != null;
    }
  }

  sum(r, field) {
    let res = 0;
    for (let i = 0; i < r.length; i++) {
      res += r[0][field];
    }

    return res;
  }

  seeTravels(d) {
    this.shTable2 = true;
    this.travels = d;
  }
}
